var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select-special-conditions"},_vm._l((_vm.changedList),function(item,index){return _c('AppCheckbox',{key:`select-special-conditions-${index}`,staticClass:"select-special-conditions__checkbox",attrs:{"label":item.label,"isChecked":item.checked},on:{"clicked":function($event){return _vm.setList(item)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }